import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { GENERATE_STATE } from '../../constants/FJEnumConstant';
import type { FJGeneratingVideoMeta } from '@src/types/FJProject';

/** 单步任务状态：已完成 / 进行中 / 未开始（完成/未开始与 `GENERATE_STATE` 取值一致） */
export type FJGeneratingTaskStatus = typeof GENERATE_STATE.SUCCEEDED | 'loading' | typeof GENERATE_STATE.PENDING;

export type FJGeneratingTaskItem = {
    id: string;
    /** 文案键名，与 `FJLocalStore._(labelKey)` 对应 */
    labelKey: string;
    status: FJGeneratingTaskStatus;
};

export type FJGeneratingPageState = {
    /** 总进度 0–100 */
    overallProgress: number;
    video: FJGeneratingVideoMeta;
};

const initialState: FJGeneratingPageState = {
    overallProgress: 0,
    video: {
        thumbnailUrl: '',
        title: '',
        sourceUrl: '',
        resolutionLabel: '',
        youtubeKey: '',
        duration: 0,
        isLightVideo: false,
    },
};

const fjGeneratingPageSlice = createSlice({
    name: 'generatingPage',
    initialState,
    reducers: {
        beginGeneratingProgress: state => {
            state.overallProgress = 0;
        },
        setGeneratingOverallProgress: (state, action: PayloadAction<number>) => {
            state.overallProgress = Math.max(0, Math.min(100, action.payload));
        },
        setGeneratingVideoMeta: (state, action: PayloadAction<Partial<FJGeneratingVideoMeta>>) => {
            Object.assign(state.video, action.payload);
        },
    },
});

export const { beginGeneratingProgress, setGeneratingOverallProgress, setGeneratingVideoMeta } =
    fjGeneratingPageSlice.actions;

export default fjGeneratingPageSlice.reducer;
